// @catalog F.047 F.048
// Pantalla /mercado-libre: subir exports oficiales (ML · Amazon · Walmart) y
// listado de archivos importados con estado vivo. Los resultados viven en su
// propia pantalla /mercado-libre/resultados (pestaña por plataforma).
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { PageHead } from "../components/analytics/PageHead";
import { ImportacionMlBlock } from "../components/MercadoLibre/ImportacionMlBlock";

export function EcommerceImportacionesPage(): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ p: isMobile ? 2 : 3 }}>
      <Stack spacing={3}>
        <PageHead
          title="Importaciones ecommerce"
          subtitle="Sube el export oficial (Mercado Libre · Amazon · Walmart) y revisa el estado de cada archivo"
        />
        <ImportacionMlBlock />
      </Stack>
    </Box>
  );
}
